import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export abstract class Dialog<T = any> {
  protected translate = inject(TranslateService);
  protected dialogRef = inject<DialogRef>(DialogRef);
  protected data = inject<T>(DIALOG_DATA);
}